import { t } from 'i18next'
import { toJS } from 'mobx'
import { MdOutlineEdit } from 'react-icons/md'

export const EditButtonHandlerTask = ({ buttons, crudContext }) => {
    buttons.edit = {
        sort: 1000,
        icon: <MdOutlineEdit />,
        depFn: ({ crudContext }) =>
            !crudContext.formContext.isEditable &&
            crudContext.formContext.values?.id > 0 &&
            crudContext.accessFn({
                accessMode: 'update',
                accessItem: ({
                    ...toJS(crudContext.formContext.values),
                    _original: toJS(crudContext.formContext.initialValues),
                }),
                crudContext: crudContext,
            }),
        priority: 'button',
        size: 'middle',
        onClick: () => {
            crudContext.actions.edit(crudContext.formContext.values)
        },
        label: t('Edit', { ns: 'Core' }),
    }
}
